// extracted by mini-css-extract-plugin
module.exports = {"banner_wrapper":"DownloadAppBottomBanner_banner_wrapper__L3LY0","header":"DownloadAppBottomBanner_header__6_2Oz","button_div":"DownloadAppBottomBanner_button_div__AKDbf"};